import React from 'react';
import { CSSProp } from 'styled-components';

export interface ButtonProps {
  id?: string;
  testId?: string;
  className?: string;
  accessibleLabel?: string;
  children?: React.ReactNode;
  isDisabled?: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  css?: CSSProp;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      id = '',
      testId = '',
      accessibleLabel,
      children,
      isDisabled,
      onClick,
      css,
      ...props
    }: ButtonProps,
    forwardedRef,
  ) => (
    <button
      css={css}
      id={id}
      ref={forwardedRef}
      data-testid={testId}
      disabled={isDisabled}
      onClick={onClick}
      aria-label={accessibleLabel}
      {...props}
    >
      {children}
    </button>
  ),
);
